import script from "./SfxImageUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxImageUploader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QFile from 'quasar/src/components/file/QFile.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QFile,QCard,QIcon});
